import React from 'react';
import Heading from '../../Typography/Heading';
function DataTableEmptyMessage() {
    return (React.createElement("div", { className: "elmo-datatable__empty" },
        React.createElement(Heading, null, "No data found.")));
}
export default DataTableEmptyMessage;
